// Icon weights
const FAL = 'fal';
const FAR = 'far';
const FAS = 'fas';
// Sandbox
export const FAL_ANGLE_LEFT = [FAL, 'angle-left'];
export const FAR_CHEVRON_DOWN = [FAR, 'chevron-down'];
export const FAR_CHEVRON_UP = [FAR, 'chevron-up'];
export const FAR_MESSAGE_PEN = [FAR, 'message-pen'];
export const FAR_UNIVERSITY = [FAR, 'university'];
export const FAR_USER = [FAR, 'user'];
export const FAR_USER_CIRCLE = [FAR, 'user-circle'];
export const FAS_ANGLE_DOWN = [FAS, 'angle-down'];
export const FAS_GLOBE = [FAS, 'globe'];
export const FAS_SIGN_OUT_ALT = [FAS, 'sign-out-alt'];
export const FAS_TIMES = [FAS, 'times'];
export const FAS_USER_CIRCLE = [FAS, 'user-circle'];
// Credit Limit Increase, Manage Card Holders Icons, and Change Payment Due Date Icons
export const FAR_ARROW_UP_RIGHT = [FAR, 'arrow-up-right-from-square'];
export const FAR_CALENDAR_DAY = [FAR, 'calendar-day'];
export const FAR_CHEVRON_RIGHT = [FAR, 'chevron-right'];
export const FAR_CIRCLE_EXCLAMATION = [FAR, 'circle-exclamation'];
export const FAR_CLOCK = [FAR, 'clock'];
export const FAR_DOLLAR_SIGN = [FAR, 'dollar-sign'];
export const FAR_EXCLAMATION_TRIANGLE = [FAR, 'triangle-exclamation'];
export const FAR_LESS_THAN = [FAR, 'less-than'];
export const FAR_REGULAR_QUESTION_MARK = [FAR, 'circle-question'];
export const FAR_ROTATE_RIGHT = [FAR, 'rotate-right'];
export const FAS_CHECK_CIRCLE = [FAS, 'check-circle'];
export const FAS_CIRCLE_EXCLAMATION = [FAS, 'circle-exclamation'];
export const FAS_CIRCLE_INFO = [FAS, 'circle-info'];
export const FAS_CIRCLE_ONE = [FAS, 'circle-1'];
export const FAS_CIRCLE_TWO = [FAS, 'circle-2'];
export const FAS_EXCLAMATION_TRIANGLE = [FAS, 'triangle-exclamation'];
export const FAS_QUESTION_MARK = [FAS, 'circle-question'];
